import React from 'react';
import { Sprite } from '@pixi/react';
import { useEffect, useRef, useState } from "react";
import * as PIXI from 'pixi.js';

const PulsingSprite = ( { x, y, imageSrc, renderScale, startPulse, pulsePerSecond = 3, duration = 3_000, fadeOutDuration = 1_000, ...props } ) =>
{
  const spriteRef = useRef( null );
  const [ texture, setTexture ] = useState( null );
  const [ visible, setVisible ] = useState( false );

  useEffect( () =>
  {
    const baseTexture = PIXI.BaseTexture.from( imageSrc );
    const tex = new PIXI.Texture( baseTexture );
    setTexture( tex );
  }, [ imageSrc ] );

  useEffect( () =>
  {
    if( !texture ) return;

    let elapsed = 0;
    let rafId;
    let isFadingOut = false;
    let fadeOutFromAlpha = 0;
    let start = performance.now();
    setVisible( true );

    const update = ( now ) =>
    {
      elapsed = now - start;

      if( !spriteRef.current ) return;

      if( !isFadingOut )
      {
        const t = elapsed / ( 1000 / pulsePerSecond );
        const alpha = 0.25 * Math.sin( t * Math.PI ) + 0.75;

        if( elapsed < duration )
        {
          // Still pulsing

          spriteRef.current.alpha = alpha;
          rafId = requestAnimationFrame( update );
        }
        else
        {
          // Start fade-out
          isFadingOut = true;
          fadeOutFromAlpha = alpha;
          start = performance.now();
          rafId = requestAnimationFrame( update );
        }
      }
      else
      {
        // Fade-out phase
        const fadeElapsed = now - start;
        const progress = Math.min( fadeElapsed / fadeOutDuration, 1 );
        spriteRef.current.alpha = fadeOutFromAlpha * ( 1 - progress );

        if( progress < 1 )
        {
          rafId = requestAnimationFrame( update );
        }
        else
        {
          setVisible( false ); // finally hide
        }
      }
    };

    rafId = requestAnimationFrame( update );

    return () => cancelAnimationFrame( rafId ); // cleanup

  },
    [ x, y, startPulse, texture, pulsePerSecond, duration, fadeOutDuration ]	// Dependency array
  );

  if( !texture || !visible ) return null;

  return (
    <Sprite
      ref={ spriteRef }
      texture={ texture }
      scale={ renderScale }
      x={ x * renderScale }
      y={ y * renderScale }
      tint={ props.tint ?? 0xffffff }
      anchor={ 0.5 }
    />
  );
};

export default PulsingSprite;
